import { render } from "./NeighborhoodDetail.vue?vue&type=template&id=496993c2&scoped=true"
import script from "./NeighborhoodDetail.vue?vue&type=script&lang=js"
export * from "./NeighborhoodDetail.vue?vue&type=script&lang=js"

import "./NeighborhoodDetail.vue?vue&type=style&index=0&id=496993c2&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496993c2"]])

export default __exports__